import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../context/ToastContext';
import { validate, validators, hasErrors } from '../../utils/validators';
import './Login.css';

const Login = () => {
  const [form,   setForm]   = useState({ email: '', password: '' });
  const [errors, setErrors] = useState({});
  const [loading,setLoading]= useState(false);
  const { login } = useAuth();
  const toast = useToast();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm(p => ({ ...p, [e.target.name]: e.target.value }));
    if (errors[e.target.name]) setErrors(p => ({ ...p, [e.target.name]: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate(form, {
      email:    [validators.required, validators.email],
      password: [validators.required]
    });
    if (hasErrors(errs)) { setErrors(errs); return; }
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate('/admin/dashboard', { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.error || 'Login failed. Check your credentials.');
    } finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-left">
        <div className="login-brand">
          <div className="login-logo">E</div>
          <h1>EventHub</h1>
          <p>Admin Portal</p>
        </div>
        <ul className="login-features">
          <li><span>▦</span> Manage events and sessions</li>
          <li><span>👥</span> Track registrants and payments</li>
          <li><span>📊</span> Real-time analytics dashboard</li>
          <li><span>📢</span> Broadcast to your audience</li>
        </ul>
      </div>

      <div className="login-right">
        <div className="login-card">
          <div className="login-card-header">
            <h2>Welcome back</h2>
            <p>Sign in to your admin account</p>
          </div>

          <form onSubmit={handleSubmit} noValidate>
            <div className="form-group">
              <label className="form-label">Email address <span className="required">*</span></label>
              <input
                type="email" name="email" value={form.email}
                onChange={handleChange} className={`form-control ${errors.email ? 'error' : ''}`}
                placeholder="admin@example.com" autoComplete="email" autoFocus
              />
              {errors.email && <p className="form-error">⚠ {errors.email}</p>}
            </div>

            <div className="form-group">
              <label className="form-label">Password <span className="required">*</span></label>
              <input
                type="password" name="password" value={form.password}
                onChange={handleChange} className={`form-control ${errors.password ? 'error' : ''}`}
                placeholder="Your password" autoComplete="current-password"
              />
              {errors.password && <p className="form-error">⚠ {errors.password}</p>}
            </div>

            <button type="submit" className="btn btn-secondary btn-full btn-lg" disabled={loading}>
              {loading ? <><span className="spinner"/> Signing in…</> : 'Sign in →'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
